import * as React from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';
import './coursePage.scss';

// toast
import 'react-toastify/dist/ReactToastify.css';

// flags 
import 'flag-icon-css/css/flag-icon.css';

// services
import {createItemGen, currentBaseUrl, currentUser, currentUserId, getGeneralSmartTableData, isUserLoggedIn, updateItemGen, uploadItem} from '../../common/services';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

// reactstrap
// import {Col, Row } from 'reactstrap';
import SmartDataTable from 'react-smart-data-table'

// hidable progress
import HidableProgress from '../../common/hidableProgress.Component';

// radio
import Radio from '@material-ui/core/Radio';

// draglist
import ReactDragList from 'react-drag-list';
import 'react-drag-list/assets/index.css';

// tabs
import {Breadcrumb, BreadcrumbItem, Button,ButtonDropdown, Card, CardBody, CardHeader,Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Row, TabContent, Table, TabPane} from 'reactstrap';

class SingleCoursePage extends React.Component {
    public state = {
      activeTab: '1',
      answereditmodal: false,
      answerfields: {
        answer: 'AnswerCopy',
        id: 'id',
      },
      answermodal: false,
      answers: [],
      assessment_info: {},
      assessmentfields: {
        enabled: 'Enabled',
        id: 'id',
        name: 'Title',
        version: 'Version',
      },
      assessmentuploadmodal: false,
      assetfields: {
        id: 'id',
        name: 'Title',
        },
      assets: [],
      baseurl: currentBaseUrl(),
      course_lessons: [],
     
      courselessonfields: {
          colour: 'Colour',
          description: 'Description',
          id: 'id',
          name: 'Title',
      },
      courselessonmodal: false,
      currentquestionidx: 0,
      destination: '',
      feedbackmodal: false,
      iconfields:{
        id: 'id',
        name: 'Title',
      },
      icons: [],
      lessonfields: {
        id: 'id',
        name: 'Title',
      },
      lessons: [],
      loaded: false,
      mounted: false,
      navigate: false,
      processingmodal: false,
      question_groups: [],
      questionanswers: [],
      questionfields: {
        id: 'id',
        question: 'Question',
        },
      questionmodal: false,
      tologin: false,
      uploadprogress: 0,
      uploadstatus: "active",
      username: '',
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this); 
        this.setTab = this.setTab.bind(this); 
        this.assessmentuploadtoggle = this.assessmentuploadtoggle.bind(this); 
        this.courselessontoggle = this.courselessontoggle.bind(this); 
        this.answertoggle = this.answertoggle.bind(this); 
        this.behaviourtoggle = this.behaviourtoggle.bind(this);
        this.answeredittoggle = this.answeredittoggle.bind(this);
        this.feedbacktoggle = this.feedbacktoggle.bind(this);  
        this.feedbackSubmit = this.feedbackSubmit.bind(this);
        this.orderSubmit = this.orderSubmit.bind(this); 
        // progress
        this.onuploadprogress = this.onuploadprogress.bind(this);
        this.onuploadcomplete = this.onuploadcomplete.bind(this); 
        // row events
        this.handleAddAnswerClicked = this.handleAddAnswerClicked.bind(this); 
        this.handleEditAnswerClicked = this.handleEditAnswerClicked.bind(this);
        this.refreshCurrentAnswers = this.refreshCurrentAnswers.bind(this); 

        this.onEnableSelected = this.onEnableSelected.bind(this); 
        this.onDisableSelected = this.onDisableSelected.bind(this); 
    }

    public assessmentuploadtoggle() {
        this.setState({
          assessmentuploadmodal: !this.state.assessmentuploadmodal,
        });
    }

    public courselessontoggle() {
        this.setState({
          courselessonmodal: !this.state.courselessonmodal,
        });
    }

    public orderSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        
        const item = {
            DisplayItems: JSON.stringify(this.state.course_lessons),
        }

        console.log(item);
        
        createItemGen( 'admin/course_lessons/update_order/', item, text => this.handleGenCreatedItemLoaded('admin/course_lessons/by_course/?id=' + this.currentid(), 'course_lessons', 'course_lessons',text));
      }

    public answertoggle() {
        this.setState({
          answermodal: !this.state.answermodal,
        });
    }

    public answeredittoggle() {
        this.setState({
          answereditmodal: !this.state.answereditmodal,
        });
    }

    public behaviourtoggle() {
        this.setState({
          courselessonmodal: !this.state.courselessonmodal,
        });
    }

    public feedbacktoggle() {
        this.setState({
            feedbackmodal: !this.state.feedbackmodal,
        });
    }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public checkFile(fname) {
        let fileExtension = "";
        if (fname.lastIndexOf(".") > 0) {
            fileExtension = fname.substring(fname.lastIndexOf(".") + 1, fname.length);
        }
        if (fileExtension.toLowerCase() === "csv") {
            return true;
        }
        else {
            toast.warn(fname + " is not a valid CSV file for upload");
            return false;
        }
    }

    public onuploadprogress(val) {
        console.log(val);
        this.setState({uploadprogress: parseFloat(val)})
    }

    public onuploadcomplete(resp, refreshpath, refreshkey, arraykey) {
        if(resp.code ===200){
            this.setState({uploadstatus: "success"});
            toast.success('Successful upload');
            this.setState({processingmodal: false});
            getGeneralSmartTableData( refreshpath, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));
            
            if(refreshkey ==='levels') {
                this.assessmentuploadtoggle();
            }
        }
        else{
            toast.error('Error uploading, check file');
            this.setState({processingmodal: false});
            this.setState({uploadstatus: "error"});
        }
    }


    public uploadSubmit = (event) => {
        event.preventDefault()

        const fileInputElement = event.target.elements.upld;
        const formData = new FormData();

        formData.append('assessment', this.currentid());

        let hasFile = false;

        for (const row of fileInputElement.files) {
            if(this.checkFile(row.name)) {
                formData.append('files', row);
                hasFile = true;
            }
            console.log(row.name);
            // console.log('acceptable:', this.checkFile(row.name));
        }

        if(hasFile){
            this.setState({processingmodal: true})
            this.setState({uploadprogress: 0})
            this.setState({uploadstatus: "active"})
            uploadItem("admin/assessment_course_lessons/csv_upload_v0/", formData, text => this.onuploadprogress(text), text => this.onuploadcomplete(text, 'admin/assessment_course_lessons/by_assessment/?id='+ this.currentid(), 'course_lessons', 'course_lessons'));
        }

        
    }

    public behaviourSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Name: event.target.elements.name.value,
        }

        createItemGen( 'admin/behaviours/', item, text => this.handleGenCreatedItemLoaded('admin/behaviours/overview_items/', 'behaviours', 'behaviours',text));
      }

      public feedbackSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Behaviour: event.target.elements.behaviour.value,
            FeedbackText_capability: event.target.elements.capability.value,
            FeedbackText_intervention: event.target.elements.intervention.value,
            FeedbackText_manifestation: event.target.elements.manifestation.value,
            RangeHigh: event.target.elements.rhigh.value,
            RangeLow: event.target.elements.rlow.value,
        }
        
        createItemGen( 'admin/lessons/', item, text => this.handleGenCreatedItemLoaded('admin/lessons/overview_items/', 'lessons', 'lessons',text));
      }

    public handleDummy(){
        console.log('done');
    }

    public filterAnswersByQuestion(questionid){
        const keyname = 'QuestionId';
        return this.state.answers.filter(answer => answer[keyname]===questionid);
    }

    public answerSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        // answer
        const item = {
            AnswerCopy: event.target.elements.answer.value,
            AnswerCopyForteacherReview: null,
            Assessment: this.currentid(),
            AssessmentQuestion: this.state.course_lessons[this.state.currentquestionidx][this.state.questionfields.id],
            Behaviour: null,
            BehaviourScore: 0,
            DisplayOrder: event.target.elements.order.value,
            Icon: null,
            score: event.target.elements.score.value,
        }

        if(this.state.assessment_info[this.state.assessmentfields.version] === 1.0) {
            item.AnswerCopyForteacherReview = event.target.elements.answerteacher.value;
            item.Behaviour = event.target.elements.behaviour.value;
            item.BehaviourScore = event.target.elements.bscore.value;
            item.Icon = event.target.elements.icon.value;
        }

        createItemGen( 'admin/assessment_question_answers/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_question_answers/by_assessment/?id=' + this.currentid(), 'answers', 'answers',text));
      }

    public groupSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Colour: event.target.elements.color.value,
            Description: event.target.elements.description.value,
            Icon: event.target.elements.icon.value,
            Name: event.target.elements.title.value,
        }

        console.log(item);
        
        createItemGen( 'admin/assessment_question_groups/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_question_groups/overview_items/', 'question_groups', 'question_groups',text));
      } 

      public courselessonSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Colour: event.target.elements.colour.value,
            Course: this.currentid(),
            Description: event.target.elements.description.value,
            DisplayOrder: event.target.elements.order.value,
            Lesson: event.target.elements.lesson.value,
            Name: event.target.elements.title.value,
            User: currentUserId(),
        }
        
        createItemGen( 'admin/course_lessons/', item, text => this.handleGenCreatedItemLoaded('admin/course_lessons/by_course/?id=' + this.currentid(), 'course_lessons', 'course_lessons',text));
      }

      public handleGenSmartDataLoaded(key,objkey, res) {
        if(res.code ===200){
            console.log(key);
            this.setState({loaded: true});
            this.setState({[key]: res.response[objkey]});
        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }

    
    public handleGenCreatedItemLoaded(fetchendpoint,refreshkey, arraykey, res) {
        if(res.code ===200){
            toast.success('Request successful');
            getGeneralSmartTableData( fetchendpoint, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));
            if(refreshkey === 'course_lessons') {
                if(this.state.courselessonmodal) {
                    setTimeout(this.courselessontoggle, 100); 
                }
            } 
            else if(refreshkey === 'behaviours') {
                setTimeout(this.behaviourtoggle, 100); 
            } 
            else if(refreshkey === 'lessons') {
                setTimeout(this.feedbacktoggle, 100); 
            } 
            else if(refreshkey === 'answers') {
                setTimeout(this.answertoggle, 100); 
            } 
            
            this.setState({processingmodal: false});
        }
        if(res.code ===404){
            toast.error('Request failed, try again');
            this.setState({processingmodal: false});
        }
        if(res.code ===401){
            toast.warn('Request unauthorized');
            this.onLogout('arg');
        }
    }


    public setTab(param, e) {
        this.setState({
        activeTab: param
         });
    }

    
    public openWidget(param, e) {
        console.log('widget: ' + param)
        this.setState({destination: currentBaseUrl() + param})
        this.setState({navigate: true})
    }

    public onChange(arg) {
        console.log('On change', arg);
    }

    public handleAddAnswerClicked(idx, e) {
        console.log('idx', idx);
        this.setState({currentquestionidx: idx});
        this.answertoggle();
    }

    public handleEditAnswerClicked(idx, e) {
        console.log('idx', idx);
        this.setState({currentquestionidx: idx, questionanswers: []});
        setTimeout(this.refreshCurrentAnswers, 100);
    }

    public refreshCurrentAnswers(){
        this.answeredittoggle();
        getGeneralSmartTableData( 'admin/assessment_question_answers/by_question/?id=' + this.state.course_lessons[this.state.currentquestionidx][this.state.questionfields.id], text => this.handleGenSmartDataLoaded('questionanswers', 'answers',text));
    }

    public onRowClick(event, { rowData, rowIndex, tableData }) {
        const { title } = rowData;
        console.log(title);
    }

    public componentDidMount() {
        if(!isUserLoggedIn()){
            this.setState({ tologin: true });
          }
        else{
            this.setState({ username: currentUser()});
            getGeneralSmartTableData( 'admin/assessment_question_groups/overview_items/', text => this.handleGenSmartDataLoaded('question_groups', 'question_groups',text));
            getGeneralSmartTableData( 'admin/icons/overview_items/', text => this.handleGenSmartDataLoaded('icons', 'icons',text));
            getGeneralSmartTableData( 'admin/course_lessons/by_course/?id=' + this.currentid(), text => this.handleGenSmartDataLoaded('course_lessons', 'course_lessons',text));
            getGeneralSmartTableData( 'admin/lessons/overview_items/', text => this.handleGenSmartDataLoaded('lessons', 'lessons',text));
            getGeneralSmartTableData( 'admin/assessments/' + this.currentid() +'/assessment_summary/', text => this.handleGenSmartDataLoaded('assessment_info', 'assessment_info',text));
        }

        this.setState({ mounted: true});
        console.log(this.currentid());
    }

    public currentid (){
        const key1 = 'match';
        return this.props[key1].params.id
    }

    public questiondisplay (){
        if (this.state.course_lessons.length > 0) {
            return (
                <h4>{this.state.course_lessons[this.state.currentquestionidx][this.state.questionfields.question]}</h4> 
              );
        }
        else{
            return (
                <h4>No question to display</h4>  
              );
        }
    }

    public filteredanswerdisplay (){
        if (this.state.course_lessons.length > 0 && this.state.questionanswers.length > 0) {
            return (
                <div>
                    
                        <ul>
                            {this.state.questionanswers.map(d => <li key={d[this.state.answerfields.id]}> <Row> <Col>{d[this.state.answerfields.answer]}</Col> <Col><i className="fa fa-trash"style={{fontSize: 30}}/></Col> </Row> </li>)} 
                        </ul>
                </div>
                
              );
        }
        else{
            return (
                <div>
                    <p>No answers to display</p>  
                </div>
                
              );
        }
    }

    public assessmentenable () {
        if (this.state.assessment_info[this.state.assessmentfields.name]) {
            return (
                <div>
                    <ul>
                        <li>
                            <Radio
                                checked={this.state.assessment_info[this.state.assessmentfields.enabled]}
                                id={"enabled"}
                                value={1}
                                onClick={this.onEnableSelected}
                                // onClick={selectionChanges}
                            /> 
                            Enabled
                        </li>
                        <li>
                            <Radio
                                checked={!this.state.assessment_info[this.state.assessmentfields.enabled]}
                                id={"disabled"}
                                value={0}
                                onClick={this.onDisableSelected}
                                // onClick={selectionChanges}
                            /> 
                            Disabled
                        </li>  
                    </ul>
                </div>
                
              );
        }
        else{
            return (
                <Loader/>
              );
        }
    
    }
    public optionalquestionformfields () {
        if (this.state.assessment_info[this.state.assessmentfields.version]) {
            
            if (this.state.assessment_info[this.state.assessmentfields.version] === 1.0){
                return (
                    <Row>
                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="color">For Teacher Review</Label>
                                                <Input type="text" id="review" name="review" placeholder="For teacher review" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="asset">Featured Asset</Label>
                                                <Input type="select" id="asset" name="asset" placeholder="asset" required={true} >
                                                    {this.state.assets.map(d => <option key={d[this.state.assetfields.id]} value={d[this.state.assetfields.id]}> {d[this.state.assetfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="icon">Icon</Label>
                                                <Input type="select" id="icon" name="icon" placeholder="Icon" required={true} >
                                                    {this.state.icons.map(d => <option key={d[this.state.iconfields.id]} value={d[this.state.iconfields.id]}> {d[this.state.iconfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                    </Row>
                );
            }
            else{
                return (
                    <div/>
                );
            }
        }
        else{
            return (
                <div/>
            );
        }
    }

    
    public onEnableSelected(event) {
        
        const item = {
            setting: 1
        }
        const retVal = confirm("Do you want to continue ?");
        if(retVal === true) {
                  console.log('change accepted');
                  updateItemGen( 'admin/assessments/' + this.currentid() + '/enable_assessment/', item,text => this.handleGenCreatedItemLoaded('admin/assessments/' + this.currentid() +'/assessment_summary/', 'assessment_info', 'assessment_info',text));
                  return true;
        } else {
            console.log('change canceled')
            return false;
        }
    }

    public onDisableSelected(event) {
        const item = {
            setting: 0
        }
        const retVal = confirm("Do you want to continue ?");
        if(retVal === true) {
                  console.log('change accepted');
                  // updateItemGen( 'admin/assessments/' + this.currentid() + '/enable_assessment/', item,text => this.handleGenCreatedItemLoaded('admin/assessments/' + this.currentid() +'/assessment_summary/', 'assessment_info', 'assessment_info',text));
                  return true;
        } else {
            console.log('change canceled')
            return false;
        }
    }


    public draglist()  {

        return(
            <ReactDragList
                dataSource={this.state.course_lessons}
                    rowKey="title"
                   // tslint:disable-next-line jsx-no-lambda
                    row = {(record, index) => 
                                                <div key={index} style={{ color: '#FFFF', backgroundColor: '#2DB7F5'  , border: 'none', margin: 13, padding: 9}}>
                                                     <div className="simple-drag-row-title" style={{margin: 3}}>{record[this.state.courselessonfields.name]}</div>
                                                        <span style={{margin: 3}}>{record[this.state.courselessonfields.description]}</span>
                                                    </div>
                                            }
                                            handles={false}
                                            className="simple-drag"
                                            rowClassName="simple-drag-row"
                                            // onUpdate={this._handleUpdate}
                                />
        );
    }

    public render() {
        if (this.state.tologin === true) {
           return <Redirect to='/login'/>
        }
        if (this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }

    

        const groupfields= {
            id: 'id',
            name: 'Title',
        }

            
        const questionheaders = {
            UpdatedDateTime: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-plus-square"
                    style={{ cursor: 'pointer', margin: 6 }}
                    onClick={this.handleAddAnswerClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(this, idx)}
                    role='button'
                  />
                  <i
                    className="fa fa-folder-open"
                    style={{ cursor: 'pointer' , margin: 6}}
                    onClick={this.handleEditAnswerClicked.bind(this, idx)}
                    // onKeyDown={this.handleEditAnswerClicked.bind(this, idx)}
                    role='button'
                  />
                  </div>  
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }

        const behaviourheaders = {
            UpdatedDateTime: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-edit"
                    style={{ cursor: 'pointer', margin: 6 }}
                    // onClick={this.handleAddAnswerClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(e, idx)}
                    role='button'
                  />
                  </div>  
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }

        const adminHomeStyles = {
            welcometext: {
                margin: 3,
                marginLeft: 13,
                marginTop: '2%'
            },

            modal:{
                width: '100%',
            },

            tabrow: {
                margin: 1,
                marginTop: '2%',
              },

            tabcontent: {
                margin: 1,
                marginTop: '2%'
            },

            tableHeaderButton: {
                margin: 2,
                marginLeft: 8,
            },

            widgetrow: {
              margin: 3,
              marginTop: '2%'
            },

            navitem: {
                margin: 3,
                padding: 5,
              },

            toast:{
                zIndex: 9999999,
            },
        }

        
        return (
            <div>

              <NavBar logoutParent={this.onLogout}/>

              <ToastContainer style={adminHomeStyles.toast} />

              <Breadcrumb>
                  <BreadcrumbItem><a onClick={this.openWidget.bind(this, 'home')}>Home</a></BreadcrumbItem>
                  <BreadcrumbItem active={true}>Singlecourse</BreadcrumbItem>
                </Breadcrumb>

              <div className="animated fadeIn">
              
                <Row style={adminHomeStyles.tabrow}>
                
                <Col xs="12" md="12" className="mb-4">
                    <Nav tabs={true} style={{flexWrap: 'nowrap'}}>
                           <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '1')}>
                                Lessons
                            </NavLink>
                            
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '2')}>
                                Status
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '3')}>
                                Order
                            </NavLink>
                        </NavItem>
                    </Nav>
                    
                    <div>

                        <Modal isOpen={this.state.assessmentuploadmodal} toggle={this.assessmentuploadtoggle} className="">
                            <ModalHeader toggle={this.assessmentuploadtoggle}>Upload Assessment course_lessons</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.uploadSubmit}>
                                    <Row>
                                        
                                        <Col xs="12">
                                            <FormGroup>
                                                <input id="upld" type="file" name="upld" accept=".csv" multiple={true} required={true}/>
                                            </FormGroup>
                                        </Col>


                                        <Col xs="12">
                                            <FormGroup>
                                                <HidableProgress uploadprogress={this.state.uploadprogress} uploadstatus={this.state.uploadstatus} visible={this.state.processingmodal}/>
                                            </FormGroup>
                                        </Col>
                                        
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button  color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.assessmentuploadtoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal style={adminHomeStyles.modal} isOpen={this.state.courselessonmodal} toggle={this.courselessontoggle} className="">
                            <ModalHeader toggle={this.courselessontoggle}>Create Course Lesson</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.courselessonSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="title">Name</Label>
                                                <Input type="text" id="title" name="title" placeholder="Title" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="title">Description</Label>
                                                <Input type="text" id="description" name="description" placeholder="description" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="0">0</option>
                                                    {this.state.course_lessons.map((d, i) => <option key={d[this.state.questionfields.id]} value={i + 1}>  {i +1}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="lesson">Lesson</Label>
                                                <Input type="select" id="lesson" name="lesson" placeholder="lesson" required={true} >
                                                    {this.state.lessons.map(d => <option key={d[this.state.lessonfields.id]} value={d[this.state.lessonfields.id]}> {d[this.state.lessonfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label htmlFor="color">Colour</Label>
                                                <Input type="select" id="colour" name="colour" placeholder="colour" required={true} >
                                                    <option value="white">white</option>
                                                    <option value="red">Red</option>
                                                    <option value="blue">Blue</option>
                                                    <option value="grey">Grey</option>
                                                    <option value="pink">Pink</option>
                                                    <option value="green">Green</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.courselessontoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        

                        <Modal style={adminHomeStyles.modal} isOpen={this.state.answereditmodal} toggle={this.answeredittoggle} className="">
                            <ModalHeader toggle={this.answeredittoggle}>Edit Answers</ModalHeader>
                            <ModalBody>
                                <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label >Question</Label>
                                                {this.questiondisplay()}
                                                
                                            </FormGroup>
                                        </Col>  
                                        <Col xs="12">
                                        <Loader loaded={this.state.questionanswers.length > 0}>
                                            {this.filteredanswerdisplay()}
                                        </Loader>
                                            
                                        </Col> 
                                </Row>
                            
                            </ModalBody>
                        </Modal>
                    </div>
                    <TabContent activeTab={this.state.activeTab} style={adminHomeStyles.tabcontent}>
                        <TabPane tabId="1">
                            <Card>
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Course Lessons
                                    <Button color="primary" onClick={this.courselessontoggle}  style={adminHomeStyles.tableHeaderButton}>New Course Lesson</Button>
                                </CardHeader>
                                <CardBody>
                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                        data={this.state.course_lessons}
                                        headers={questionheaders}
                                        name='course_lessons'
                                        perPage={10}
                                        className='ui compact selectable table admintable'
                                        sortable={false}
                                    />
                                    </Loader>
                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="2">
                            <Card>
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Options
            
                                </CardHeader>
                                <CardBody>
                                    {this.assessmentenable()}
                                </CardBody>
                            </Card>
                        </TabPane>

                        <TabPane tabId="3">
                            <Card>
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Order
            
                                </CardHeader>
                                <CardBody>
                                    {this.draglist()}
                                    
                                    <Button style={{marginLeft: 13, borderRadius: '15px', width: '13em'}} onClick={this.orderSubmit}>Change Order</Button>
                                </CardBody>
                            </Card>
                        </TabPane>
                        
                    </TabContent>
                </Col>
          </Row>
              
              </div>
              
            </div>      
        )
    }
}

export default SingleCoursePage;


// WEBPACK FOOTER //
// ./src/pages/SingleCourse/coursePage.Component.tsx